import BaseModel from './BaseModel';
import {StringAttribute} from '../../components/container/attributes/StringAttribute.ts';
import {LocationAttribute} from '../../components/container/attributes/LocationAttribute.ts';

export default class TrackerCustomer extends BaseModel {
  constructor({
    id,
    number = undefined,
    no = undefined,
    fixedPosition = undefined,
    fixed_position = undefined,
  }) {
    super(id, number || no, undefined);
    this.fixedPosition = fixedPosition ?? fixed_position ?? null;
  }

  get fullDesignation() {
    return this.number;
  }

  static get apiRoute() {
    return 'tracker';
  }
  static get detailPageRoute() {
    return 'trackerDetail';
  }
  static get listPageRoute() {
    return 'trackerList';
  }
  static get fkName() {
    return 'tracker_id';
  }
  get fkName() {
    return TrackerCustomer.fkName;
  }
  static get config() {
    return {
      addable: true,
      importable: false,
      deletable: false,
    };
  }

  get apiRoute() {
    return TrackerCustomer.apiRoute;
  }
  get detailPageRoute() {
    return TrackerCustomer.detailPageRoute;
  }
  get listPageRoute() {
    return TrackerCustomer.listPageRoute;
  }
  get config() {
    return TrackerCustomer.config;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['number']);
  }
  static get entityListDisplayAttrs() {
    return ['number'];
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['number']);
  }

  static get joinAttrsKey() {
    return ['number'];
  }

  static get allAttributes() {
    return [
      new StringAttribute({
        name: 'number',
        column: 'no',
        tableProperties: {
          header: 'hit-app.common.no',
          maxWidth: '1fr',
        },
      }),
      new LocationAttribute({
        name: 'fixedPosition',
        column: 'fixed_position',
      }),
    ];
  }
}
